import styled from 'styled-components';

import { cellWidth } from '../utils/constants';

const HiddenAction = styled.div`
  width: ${cellWidth};
`;

export { HiddenAction };
